const componentSerializationKey = 'PlatsaSoftClosingHingeComponent';
export class PlatsaSoftClosingHingeComponentSerializer {
    constructor() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    canHandle(serializationKey) {
        return serializationKey === componentSerializationKey;
    }
    deserialize(serializationKey) {
        switch (serializationKey) {
            case componentSerializationKey:
                return new PlatsaSoftClosingHingeComponent();
        }
        return null;
    }
}
class PlatsaSoftClosingHingeComponent {
    constructor() {
        this.typeId = PlatsaSoftClosingHingeComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
    }
    eq() {
        return false;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    serializationKey() {
        return componentSerializationKey;
    }
}
PlatsaSoftClosingHingeComponent.id = 2073; // Note that this Id is save to VPC and should not be changed
export default PlatsaSoftClosingHingeComponent;
//# sourceMappingURL=PlatsaSoftClosingHingeComponent.js.map